module.exports = __webpack_public_path__ + "img/tacet-eyes-emotion.234192f7.gif";